import { render, staticRenderFns } from "./shopManagement.vue?vue&type=template&id=5f5899d6&scoped=true&"
import script from "./shopManagement.vue?vue&type=script&lang=js&"
export * from "./shopManagement.vue?vue&type=script&lang=js&"
import style0 from "./shopManagement.vue?vue&type=style&index=0&id=5f5899d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5899d6",
  null
  
)

export default component.exports